import { reactive } from "vue";
import store from "../../../store";
import { createLoading } from "../../../utils/loading";
import { createPage } from "../../../utils/page";
import { flatWhereGroup } from "../../../utils/search";
import { createColumns } from "./notification.section";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/notification/notification";
export const routerPrefix = "notifications";

export const callSave = ({ form }) => store.dispatch(`${actionPrefix}/save`, { data: form });
export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callActive = ({ id }) => store.dispatch(`${actionPrefix}/active`, { id });
export const callArchive = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id });
export const callDelete = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id, config: { params: { isHardDelete: true } } });
export const callActiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/activeAll`, { ids });
export const callArchiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids });
export const callDeleteAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids, config: { params: { isHardDelete: true } } });
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria });

export const onSearch = ({ props, page }) => {
    const where = page.where || [];
    setIsLoading(true);
    window.onSearch?.({ page });
    return callSearch({ criteria: { ...page, data: [], where: [...where, ...createWhereRole({ props })] } })
        .then((page) => (state.page = { ...page, where }))
        .finally(() => setIsLoading(false));
};

export const createWhereRole = () => {
    const whereGroup = [];
    const userInfo = store.state.resource.auth.info?.user;
    whereGroup.push([{ name: "refTo.username", type: "String", operator: "=", value: userInfo.username }]);
    return flatWhereGroup({ where: whereGroup, logic: "OR" });
};

export const initState = () => {
    state.manages = [];
    state.manageExtras = [];
    state.rowActions = [];
};

export const state = reactive({
    columns: createColumns(),
    page: createPage({ options: { select: ["*", "refFrom.fullName", "refFrom.refImage.url"], sort: [{ name: "createDate", type: "DESC" }] } }),
    tableOptions: { search: { activeKey: "Search" } },
});
